import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
// FUNCIONES
import { formatearMoneda } from "../../funcionesDatos/Moneda";
import { formatearFechaHora } from "../../funcionesDatos/fechas";

function ListaDesembolsos({ desembolsos, totalAPagarGeneral, totalVendedores, totalReservas, ahoraDesembolsos, tipoDesembolsos = "por_enviar" }) {
    const navigate = useNavigate();
    const [reintentando, setReintentando] = useState(null); // idProveedor en proceso de reintento
    const [notificando, setNotificando] = useState(null); // idProveedor en proceso de notificación manual
    function obtenerMonedaDesembolso(desembolso) {
        return desembolso?.reservas?.[0]?.cobro?.moneda || "COP";
    }

    function mostrarMoneda(valor, moneda = "COP") {
        return formatearMoneda(Number(valor || 0), moneda);
    }

    function mostrarFechaHora(fecha) {
        return formatearFechaHora(fecha) || "NA";
    }

    function textoTotalTarjeta() {
        if (tipoDesembolsos === "programados") return "Total programado";
        if (tipoDesembolsos === "enviados") return "Total enviado";
        return "Total a pagar";
    }

    function textoFechaTarjeta() {
        if (tipoDesembolsos === "programados") return "Programado para";
        if (tipoDesembolsos === "enviados") return "Pagado el";
        return "Disponible desde";
    }

    function obtenerFechaPrincipal(desembolso, primeraReserva) {
        if (tipoDesembolsos === "programados") {
            return desembolso?.fechaProgramada || primeraReserva?.desembolso?.fechaProgramada || null;
        }
        if (tipoDesembolsos === "enviados") {
            return desembolso?.fechaPagado || primeraReserva?.desembolso?.fechaPagado || null;
        }
        if (tipoDesembolsos === "fallidos") {
            return primeraReserva?.desembolso?.wompiUltimoWebhookEn || null;
        }
        return desembolso?.disponibleDesde || primeraReserva?.desembolso?.disponibleDesde || null;
    }

    function textoAlertaVacia() {
        if (tipoDesembolsos === "programados") return "No hay desembolsos programados.";
        if (tipoDesembolsos === "enviados") return "No hay desembolsos enviados todavía.";
        if (tipoDesembolsos === "fallidos") return "No hay desembolsos fallidos. 🎉";
        return "No hay desembolsos pendientes por pagar.";
    }

    async function reintentarDesembolso(desembolso) {
        try {
            const idsReservas = (desembolso?.reservas || [])
                .map((reserva) => reserva?._id || reserva?.idReserva)
                .filter(Boolean);

            if (idsReservas.length === 0) return;

            setReintentando(desembolso.idProveedor);

            await axios.post("/reintentar-desembolso-fallido", {
                params: { idProveedor: desembolso.idProveedor, idsReservas },
            });

            await Swal.fire({
                icon: "success",
                title: "Reenviado a pendientes",
                text: "Este desembolso volvió a la pestaña \"Por enviar\". Confirma que el vendedor corrigió sus datos bancarios antes de pagar de nuevo.",
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });

            window.location.reload();
        }
        catch (err) {
            console.log("Error reintentando desembolso:", err);
            await Swal.fire({
                icon: "error",
                title: "No se pudo reintentar",
                text: err?.response?.data?.mensaje || "Ocurrió un error. Intenta de nuevo.",
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
        finally {
            setReintentando(null);
        }
    }

    async function notificarDesembolso(desembolso) {
        try {
            const idsReservas = (desembolso?.reservas || [])
                .map((reserva) => reserva?._id || reserva?.idReserva)
                .filter(Boolean);

            setNotificando(desembolso.idProveedor);

            await axios.post("/notificar-desembolso-fallido", {
                params: { idProveedor: desembolso.idProveedor, idsReservas },
            });

            await Swal.fire({
                icon: "success",
                title: "Notificación enviada",
                text: "Le avisamos al vendedor por correo, push y campanita en la app.",
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
        catch (err) {
            console.log("Error notificando desembolso:", err);
            await Swal.fire({
                icon: "error",
                title: "No se pudo notificar",
                text: err?.response?.data?.mensaje || "Ocurrió un error. Intenta de nuevo.",
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
        finally {
            setNotificando(null);
        }
    }

    function verDesembolsosUsuario(desembolso) {
        navigate("/admin/ver-desembolso", {
            state: {
                idProveedor: desembolso?.idProveedor,
                vendedor: desembolso?.vendedor,
                reservas: desembolso?.reservas || [],
                totalAPagar: desembolso?.totalAPagar || 0,
                totalReservas: desembolso?.totalReservas || 0,
                tipoDesembolsos,
            }
        });
    }

    return (
        <div className="container-fluid px-0">

             

            

            {desembolsos.length === 0 ? (
                <div className="alert alert-light border rounded-4">{textoAlertaVacia()}</div>
            ) : (
                <div className="d-flex flex-column gap-4">
                    {desembolsos.map((desembolso) => {
                        const vendedor = desembolso?.vendedor || {};
                        const avatar = vendedor?.avatar || "/imagenes/marca/avatar.png";
                        const username = vendedor?.username || "usuario";
                        const nombreCompleto = `${vendedor?.nombre || ""} ${vendedor?.apellido || ""}`.trim() || "Vendedor sin nombre";
                        const primeraReserva = desembolso?.reservas?.[0] || null;
                        const fechaPrincipal = obtenerFechaPrincipal(desembolso, primeraReserva);
                        const moneda = obtenerMonedaDesembolso(desembolso);
                        const motivoRechazo = tipoDesembolsos === "fallidos"
                            ? (primeraReserva?.desembolso?.wompiMotivoRechazo || "NA")
                            : null;

                        return (
                            <div
                                key={desembolso.idProveedor}
                                className="card shadow-sm border-0 rounded-4"
                                style={{ background: "var(--color-bg-surface)" }}
                            >
                                <div className="card-body px-4 py-4">
                                    <div className="row align-items-center g-3 g-xl-4">
                                        <div className="col-12 col-md-2 col-xl-1">
                                            <img
                                                src={avatar}
                                                alt={nombreCompleto}
                                                style={{
                                                    width: "96px",
                                                    height: "96px",
                                                    objectFit: "cover",
                                                    borderRadius: "18px",
                                                    border: "1px solid var(--color-border)",
                                                    display: "block",
                                                }}
                                            />
                                        </div>

                                        <div className="col-12 col-md-3 col-xl-3">
                                            <div className="d-flex flex-column pe-xl-2">
                                                <span
                                                    className="fw-bold text-dark"
                                                    style={{
                                                        fontSize: "1rem",
                                                        lineHeight: 1.35,
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    {nombreCompleto}
                                                </span>
                                                <span className="text-secondary mt-2" style={{ fontSize: "0.95rem" }}>
                                                    @{username}
                                                </span>
                                                <span className="text-secondary" style={{ fontSize: "0.9rem" }}>
                                                    {vendedor?.email || "Sin correo"}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-2 col-xl-2">
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>{textoTotalTarjeta()}</span>
                                                <span className="fw-bold text-dark" style={{ fontSize: "1.65rem", lineHeight: 1.05 }}>
                                                    {mostrarMoneda(desembolso?.totalAPagar, moneda)}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-2 col-xl-2">
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>Reservas</span>
                                                <span className="fw-bold text-dark" style={{ fontSize: "1.65rem", lineHeight: 1.05 }}>
                                                    {Number(desembolso?.totalReservas || 0)}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-1 col-xl-2">
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>{textoFechaTarjeta()}</span>
                                                <span className="fw-bold text-dark" style={{ fontSize: "1.05rem", lineHeight: 1.35 }}>
                                                    {mostrarFechaHora(fechaPrincipal)}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-2 col-xl-2">
                                            <div className="d-flex flex-column justify-content-center align-items-md-start h-100 gap-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary rounded-pill px-3 py-2 fw-semibold"
                                                    style={{ width: "100%", maxWidth: "220px" }}
                                                    onClick={() => verDesembolsosUsuario(desembolso)}
                                                >
                                                    {tipoDesembolsos === "enviados" ? "Ver enviados" : tipoDesembolsos === "programados" ? "Ver programados" : tipoDesembolsos === "fallidos" ? "Ver detalle" : "Ver desembolsos"}
                                                </button>

                                                {tipoDesembolsos === "fallidos" && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger rounded-pill px-3 py-2 fw-semibold"
                                                            style={{ width: "100%", maxWidth: "220px" }}
                                                            disabled={notificando === desembolso.idProveedor}
                                                            onClick={() => notificarDesembolso(desembolso)}
                                                        >
                                                            {notificando === desembolso.idProveedor ? "Notificando..." : "Notificar al vendedor"}
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-danger rounded-pill px-3 py-2 fw-semibold"
                                                            style={{ width: "100%", maxWidth: "220px" }}
                                                            disabled={reintentando === desembolso.idProveedor}
                                                            onClick={() => reintentarDesembolso(desembolso)}
                                                        >
                                                            {reintentando === desembolso.idProveedor ? "Reintentando..." : "Reintentar"}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {tipoDesembolsos === "fallidos" && (
                                        <div className="alert alert-danger rounded-4 mt-3 mb-0">
                                            <strong>Motivo del rechazo:</strong> {motivoRechazo && motivoRechazo !== "NA" ? motivoRechazo : "Wompi no envió un motivo legible — revisa el detalle."}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default ListaDesembolsos;